import React from "react";
import { graphql } from "gatsby";

import AlteredComponent from "../elements/AlteredComponent";
import CtaButton from "../elements/CtaButton";

export default function CtaBar({ data }) {
  const {
    description,
    primaryButtonText,
    primaryButtonLink,
    chatSupport,
    sticky,
  } = data;
  return (
    <section
      className={`cta-bar_section ${
        sticky ? "sticky-section" : "relative"
      } lg:flex lg:items-center px-6 lg:px-0`}
    >
      {sticky ? (
        <p className="w-full text-center font-body text-sm md:text-base text-white pt-3 lg:pt-0 lg:my-6">
          {description}
        </p>
      ) : (
        <h4 className="w-full text-center font-a3 text-xl md:text-2xl text-white pt-3 lg:pt-0">
          {description}
        </h4>
      )}

      <div className="w-full lg:w-1/4 flex flex-col md:flex-row md:justify-center lg:justify-start items-center lg:absolute lg:right-0">
        <AlteredComponent
          css={
            sticky
              ? "altered-cta-bar_cta_button_sticky"
              : "altered-cta-bar_cta_button"
          }
        >
          <CtaButton text={primaryButtonText} link={primaryButtonLink} />
        </AlteredComponent>
      </div>
    </section>
  );
}

export const query = graphql`
  fragment CtaBarComponent on DatoCmsCtaBar {
    internal {
      type
    }
    description
    primaryButtonLink
    primaryButtonText
    sticky
  }
`;
